<!--  Show indicator when a route is being loaded asynchronously/lazily -->
<div *ngIf="isLazyRouteIndicatorEnabled" class="router-load-indicator">
  {{ 'app.loading' | translate }}
</div>

<router-outlet></router-outlet>
